import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Container } from 'react-bootstrap';
import classes from './Test.module.css';

const CertificatesSection = () => {
  const certificates = useSelector((state) => state.Certificates);

  return (
    <section id='two-certificates' className={`${classes.main} ${classes.mainColor} ${classes.pb20} ${classes.p40}`}>
      <Container>
        <Row className={`${classes.pb20} text-center`}>
          <Col md={12}>
            <div className={classes.headingTag}>Certificates</div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {certificates.map((cert, index) => (
            <Col md={5} className="pb-3" key={index}>
              <img 
                src={cert.image} 
                alt={`Certificate ${index + 1}`}
                style={{
                  width: '100%',
                  height: '500px',
                  objectFit: 'contain',
                  objectPosition: 'center',
                  borderRadius: '8px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  backgroundColor: '#f8f9fa'
                }}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default CertificatesSection;